import styled from "styled-components";
export const ChatWriterStyle = styled.div`
  border-top: 1px solid #efefef;
  margin-top: 5px;
  padding: 10px 20px !important;
  .input {
  }
  .button {
    justify-content: left;
  }
  textarea {
    background-color: ${({ theme }) => theme.box};
    border: none;
    color: #646464;
    height: fit-content;
    resize: none;
    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
    }
    &::placeholder {
      color: #7d7d7d;
    }
  }
  .file {
    padding: 7px 10px;
    border: 1px solid #b6b6b6;
    border-radius: 5px;
    margin-right: 10px;
    background-color: ${({ theme }) => theme.attach};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .file > input[type="file"] {
    display: none;
  }

  .file > label {
    cursor: pointer;
  }

  .file > label:hover {
    border-color: hsl(0, 0%, 21%);
  }

  .file > label:active {
    background-color: hsl(0, 0%, 96%);
  }

  .file > label > i {
  }
  /* .file {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .file > input[type="file"] {
    display: none;
  }

  .file > label {
    font-size: 1rem;
    font-weight: 300;
    cursor: pointer;
    outline: 0;
    user-select: none;
    border-color: rgb(216, 216, 216) rgb(209, 209, 209) rgb(186, 186, 186);
    border-style: solid;
    border-radius: 4px;
    border-width: 1px;
    background-color: hsl(0, 0%, 100%);
    color: hsl(0, 0%, 29%);
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .file > label:hover {
    border-color: hsl(0, 0%, 21%);
  }

  .file > label:active {
    background-color: hsl(0, 0%, 96%);
  }

  .file > label > i {
    padding-right: 5px;
  }

  .file--upload > label {
    color: hsl(204, 86%, 53%);
    border-color: hsl(204, 86%, 53%);
  }

  .file--upload > label:hover {
    border-color: hsl(204, 86%, 53%);
    background-color: hsl(204, 86%, 96%);
  }

  .file--upload > label:active {
    background-color: hsl(204, 86%, 91%);
  } */
`;
